export type View = {
  $el: HTMLElement;
};

export class BaseRenderer {
  protected view?: View | Vue.Component;

  constructor(view?: View | Vue.Component) {
    this.view = view;
  }

  get element(): HTMLElement {
    return (this.view as View)!.$el;
  }
}
